import React, { Component } from 'react';

import OverlayCard from '../card/OverlayCard';
import withItemSelection from './ItemSelection';
import * as DataStore from "data/DataStore";
import { getTitleUi } from "data/TitleInfoSelector";

export function makeOverviewDetails(Overview, ItemDetails) {
	class OverviewDetails extends Component {
		render() {
			let render = <Overview cardModel={this.props.cardModel} onItemClick={this.props.onItemClick} onNext={this.props.onNext} onPrevious={this.props.onPrevious} />;

			if (this.props.selectedItem) {
				render = (
					<OverlayCard onClose={this.props.onClose} onNext={this.props.selectNext} onPrevious={this.props.selectPrevious} >
						<ItemDetails activeTitleUi={getTitleUi(DataStore.getJsonData())}{...this.props.selectedItem} />
					</OverlayCard>
				);
			}
			return render;
		}
	}

	return OverviewDetails;
}

const createOverviewDetails = (Overview, ItemDetails) => {
	return withItemSelection(makeOverviewDetails(Overview, ItemDetails));
}

export default createOverviewDetails;



// WEBPACK FOOTER //
// ./src/react/card/OverviewDetails.jsx